import classNames from "classnames";
import { Link } from "~/common/components/Link";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import type { CMSLinkProps } from "~/features/cms/types/props";

export const CMSLink = (props: CMSLinkProps) => {
  const { url, label, target, className } = props;
  return (
    <Link
      className={classNames("scha__cms scha__cmssection__sub--link", className)}
      href={url}
      target={target}
      iconBefore={<Icon className={"scha__link--arrow-link"} type={IconType.ChevronRight} />}
    >
      {label}
    </Link>
  );
};
